// external
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
// models
import { VuexAction } from '@andromeda/types';
import { RetailerLocation } from '@andromeda/shopping-cart-data-access-store';
import { Offer } from '@andromeda/polaris-data-access-products';
import {
    GET_IS_GO_TO_CART_OPEN,
    SET_GO_TO_CART_OPEN,
} from '@andromeda/affiliate-data-access-kroger';

import IProductSlot from '../../../models/ProductSlot';

@Component({})
export default class GoToCart extends Vue {
    @Prop({ required: true }) selectedRetailer!: RetailerLocation;

    @Prop({ required: false }) isDefault!: boolean;

    @Getter(GET_IS_GO_TO_CART_OPEN) getGoToCartOpen!: boolean;

    @Action(SET_GO_TO_CART_OPEN) setGoToCartOpen!: VuexAction<boolean>;

    @Prop({ required: true }) selectedProducts!: IProductSlot<Offer>[];

    @Prop({ required: false }) getSessionId!: string;

    @Prop({ required: false }) getPromotionId!: string;

    get logo() {
        return (this.selectedRetailer) ? this.selectedRetailer.logo : '';
    }

    get cartUrl() {
        if (!this.isDefault) {
            const chainName = this.selectedRetailer.chain.replace(/\s/g, '');
            return (this.selectedRetailer) ? `https://www.${chainName}.com/cart` : '';
        }
        return 'https://www.kroger.com';
    }

    get label() {
        return (this.selectedRetailer) ? `Go to Your ${this.selectedRetailer.chain} Cart` : '';
    }

    checkout() {
        this.close();
    }

    close() {
        this.setGoToCartOpen(false);
    }
}
